module.exports = __webpack_public_path__ + "img/technology.6bec95d1.png";